const isOutOfStock = (product) => Boolean(product?.out_of_stock) || product?.title.toLowerCase().includes('rv');

export default isOutOfStock;
